import styled, { css } from 'styled-components'
import { MenuItem as MuiMenuItem } from '@material-ui/core'
import { getFontStyle } from '@diversioteam/diversio-ds'

import { LumiNavContentWrapper } from './Lumi/lumi.styles'
import { NavbarStyleProps } from './navbar.types'

export const NavbarWrapper = styled.div<NavbarStyleProps>`
    grid-area: navbar;
    display: flex;
    flex-direction: column;
    position: static;
    overflow-y: auto;
    overflow-x: hidden;
    width: ${({ isCollapsed }) => {
        if (isCollapsed) {
            return '70px'
        }

        return '256px'
    }};
    height: 100%;
    background-color: ${({ theme }) => theme.colors.primary90};
    transition: width 0.25s ease;
    z-index: 1000;

    a {
        white-space: nowrap;
    }

    ${({ theme, isCollapsed }) => {
        if (!isCollapsed) {
            return css`
                li:has(.lumi-navbar) {
                    background: linear-gradient(180deg, ${theme.colors.primary80} 0%, #623bc44d 100%);
                    border-radius: 10px;

                    div {
                        color: ${({ theme }) => theme.colors.primaryWhite};
                    }

                    a > div:first-child {
                        margin-top: 10px;
                    }

                    ${LumiNavContentWrapper} {
                        padding: 12px 0 4px 0;
                    }
                }
            `
        }
    }}
`

export const LogoContainer = styled.div<NavbarStyleProps>`
    width: 100%;
    height: 72px;
    display: flex;
    align-items: center;
    padding: ${({ isCollapsed }) => {
        if (isCollapsed) {
            return '0 4.5px'
        }

        return '0 22px'
    }};

    img {
        display: none;

        ${({ isCollapsed }) => {
            if (isCollapsed) {
                return css`
                    &:first-child {
                        display: block;
                    }
                `
            } else {
                return css`
                    &:last-child {
                        display: block;
                    }
                `
            }
        }};
    }
`

export const MenuItem = styled(MuiMenuItem)`
    &.MuiMenuItem-root {
        ${getFontStyle('p03Regular')}
    }
`
